import(/* webpackMode: "eager" */ "/Users/dev/Develop/production/meta-portafolio/src/app/not-found.js");
